export default "__VITE_ASSET__BT5MLr7w__"